var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('change-password-modal',{ref:"passwordChangeModals",attrs:{"active":_vm.passwordModal,"error":_vm.changePasswordErr},on:{"dismiss":function($event){return _vm.dismiss('passwordModal')},"confirm":_vm.changePassword}}),_c('Home',{on:{"createSession":_vm.newSession}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }